import { Tag } from "@design-system/Tag/Tag";

import {
  formatLoginTypeLabel,
  LoginTypeValue,
} from "@utils/activityClassificationLabels";

type Props = {
  loginType?: string | null;
  compact?: boolean;
};

const colorMap: Record<
  LoginTypeValue,
  "danger" | "secondary" | "success" | "warning" | "tertiary"
> = {
  WORK_SSO: "success",
  WORK_EMAIL: "secondary",
  PERSONAL_EMAIL: "warning",
  SHARED: "danger",
  UNKNOWN: "tertiary",
};

export const LoginTypeTag = ({ loginType, compact }: Props) => {
  const label = formatLoginTypeLabel(loginType);
  if (!label || !loginType) {
    return null;
  }

  const color = colorMap[loginType as LoginTypeValue] ?? "tertiary";
  return <Tag color={color} text={label} noWrap compact={compact} />;
};
